import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "disabled", "onChange", "renderTitle", "boxProps", "value", "defaultValue"];
import React, { forwardRef, useCallback, useLayoutEffect, useRef, useState } from 'react';
import Box from '../Box';
import RightIcon from '../Icons/RightIcon';
import styled from 'styled-components';
import { focusOutline } from '../focus';
import Text from '../Text';
import { isFunction, noop } from '../utils';
import { useCombinedRefs } from '../hooks';
var ActiveOption = styled(Box).withConfig({
  displayName: "Pulldown__ActiveOption",
  componentId: "sc-1l8ql5o-0"
})([""]);
var PulldownSelect = styled(Box).attrs({
  tabIndex: 0,
  as: 'select'
}).withConfig({
  displayName: "Pulldown__PulldownSelect",
  componentId: "sc-1l8ql5o-1"
})(["position:absolute;opacity:0;left:0;height:100%;-webkit-appearance:none;top:0px;cursor:pointer;width:100%;cursor:pointer;&:focus + ", "{", "}"], ActiveOption, focusOutline);

var _ref2 = /*#__PURE__*/React.createElement(RightIcon, {
  color: "ctrl",
  width: "0.6em",
  height: "0.6em"
});

var PulldownTitle = function PulldownTitle(_ref) {
  var option = _ref.option;
  return /*#__PURE__*/React.createElement(Box, {
    maxWidth: "100%",
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "ctrl",
    mr: "5px",
    textStyle: "bodyRegular",
    truncate: true
  }, option && option.title), _ref2);
};

var getSelectedOption = function getSelectedOption(select) {
  var option = select.options[select.selectedIndex];
  return option ? {
    title: option.text,
    value: option.value
  } : null;
};

export default /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$onChange = _ref3.onChange,
      onChange = _ref3$onChange === void 0 ? noop : _ref3$onChange,
      renderTitle = _ref3.renderTitle,
      _ref3$boxProps = _ref3.boxProps,
      boxProps = _ref3$boxProps === void 0 ? {} : _ref3$boxProps,
      value = _ref3.value,
      defaultValue = _ref3.defaultValue,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var selectRef = useRef(null);
  useLayoutEffect(function () {
    if (selectRef.current !== null) {
      setSelected(getSelectedOption(selectRef.current));
    }
  }, [value, defaultValue]);
  var onChangeHandler = useCallback(function (e) {
    setSelected(getSelectedOption(e.target));

    if (isFunction(onChange)) {
      onChange(e);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    position: "relative",
    display: "inline-block"
  }, boxProps), /*#__PURE__*/React.createElement(PulldownSelect, _extends({
    defaultValue: defaultValue,
    value: value
  }, disabled ? {
    display: 'none'
  } : {}, {
    ref: useCombinedRefs(ref, selectRef),
    onChange: onChangeHandler
  }, props), children), /*#__PURE__*/React.createElement(ActiveOption, null, isFunction(renderTitle) ? renderTitle(selected) : /*#__PURE__*/React.createElement(PulldownTitle, {
    option: selected
  })));
});